module.exports = __webpack_public_path__ + "img/clean-bandit001.f6954034.jpg";